import {AnalyticsController} from '@mintdata-wsp/common/controllers/analytics/AnalyticsController';
import {CobrowseController} from '@mintdata-wsp/common/controllers/analytics/CobrowseController';
import {GoogleAnalyticsController} from '@mintdata-wsp/common/controllers/analytics/GoogleAnalyticsController';
import {HotjarController} from '@mintdata-wsp/common/controllers/analytics/HotjarController';
import {IntercomController} from '@mintdata-wsp/common/controllers/analytics/IntercomController';
import {LogRocketController} from '@mintdata-wsp/common/controllers/analytics/LogRocketController';
import {MixpanelController} from '@mintdata-wsp/common/controllers/analytics/MixpanelController';
import {UpscopeController} from '@mintdata-wsp/common/controllers/analytics/UpscopeController';
import {ArtifactsController} from '@mintdata-wsp/common/controllers/artifacts/ArtifactsController';
import {EmojisController} from '@mintdata-wsp/common/controllers/assets/EmojisController';
import {FontsController} from '@mintdata-wsp/common/controllers/assets/FontsController';
import {GraphicsController} from '@mintdata-wsp/common/controllers/assets/GraphicsController';
import {IconsController} from '@mintdata-wsp/common/controllers/assets/IconsController';
import {Illustrations1Controller} from '@mintdata-wsp/common/controllers/assets/Illustrations1Controller';
import {Illustrations2Controller} from '@mintdata-wsp/common/controllers/assets/Illustrations2Controller';
import {UploadedImagesController} from '@mintdata-wsp/common/controllers/assets/UploadedImagesController';
import {OAuth2Controller} from '@mintdata-wsp/common/controllers/auth/oauth2/OAuth2Controller';
import {BasesController} from '@mintdata-wsp/common/controllers/bases/BasesController';
import {BindingsController} from '@mintdata-wsp/common/controllers/bindings/BindingsController';
import {CacheController} from '@mintdata-wsp/common/controllers/cache/CacheController';
import {ApplicationContextController} from '@mintdata-wsp/common/controllers/context/ApplicationContextController';
import {HostContextController} from '@mintdata-wsp/common/controllers/context/HostContextController';
import {DesignStateController} from '@mintdata-wsp/common/controllers/designState/DesignStateController';
import {FilesController} from '@mintdata-wsp/common/controllers/files/FilesController';
import {FlowCloudController} from '@mintdata-wsp/common/controllers/flow/FlowCloudController';
import {FlowController} from '@mintdata-wsp/common/controllers/flow/FlowController';
import {FlowSimulationController} from '@mintdata-wsp/common/controllers/flow/FlowSimulationController';
import {FlowSimulationMessagesController} from '@mintdata-wsp/common/controllers/flow/FlowSimulationMessagesController';
import {FlowSimulationStatusController} from '@mintdata-wsp/common/controllers/flow/FlowSimulationStatusController';
import {NamedRangesController} from '@mintdata-wsp/common/controllers/ranges/NamedRangesController';
import {ClientFunctionsController} from '@mintdata-wsp/common/controllers/spreadsheet/code/ClientFunctionsController';
import {FormulaInputController} from '@mintdata-wsp/common/controllers/spreadsheet/formula/FormulaInputController';
import {MeshStateController} from '@mintdata-wsp/common/controllers/spreadsheet/mesh/MeshStateController';
import {NestedFrameController} from '@mintdata-wsp/common/controllers/spreadsheet/NestedFrameController';
import {SheetController} from '@mintdata-wsp/common/controllers/spreadsheet/SheetController';
import {SheetSettingsController} from '@mintdata-wsp/common/controllers/spreadsheet/SheetSettingsController';
import {SpreadsheetsMainController} from '@mintdata-wsp/common/controllers/spreadsheet/SpreadsheetsMainController';
import {SpreadsheetTabsController} from '@mintdata-wsp/common/controllers/spreadsheet/SpreadsheetTabsController';
import {WorkbookController} from '@mintdata-wsp/common/controllers/spreadsheet/WorkbookController';
import {AnimationController} from '@mintdata-wsp/common/controllers/surface/animation/AnimationController';
import {SurfaceAreaController} from '@mintdata-wsp/common/controllers/surface/SurfaceAreaController';
import {SurfaceDnDController} from '@mintdata-wsp/common/controllers/surface/SurfaceDnDController';
import {BuildVersionController} from '@mintdata-wsp/common/controllers/version/BuildVersionController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import _merge from 'lodash/merge';

export class SpreadsheetControllers
{
    // Core Model
    public readonly main:SpreadsheetsMainController = new SpreadsheetsMainController();
    public readonly workbook:WorkbookController = new WorkbookController();
    public readonly sheet:SheetController = new SheetController();
    public readonly nestedFrame:NestedFrameController = new NestedFrameController();
    // public readonly cloudSheet:CloudSheetController = new CloudSheetController();

    // Named ranges
    public readonly namedRanges:NamedRangesController = new NamedRangesController();

    // Cell Data
    public readonly clientFunctions:ClientFunctionsController = new ClientFunctionsController();
    public readonly formulaInput:FormulaInputController = new FormulaInputController();

    // View: Mesh
    public readonly mesh:MeshStateController = new MeshStateController();

    // View: SheetSettings
    public readonly sheetSettings:SheetSettingsController = new SheetSettingsController();
    // public readonly cloudSheetSettings:CloudSheetSettingsController = new CloudSheetSettingsController();

    // View: Tabs
    public readonly tabs:SpreadsheetTabsController = new SpreadsheetTabsController();
}

export class AssetsControllers
{
    public readonly graphics:GraphicsController = new GraphicsController();
    public readonly icons:IconsController = new IconsController();
    public readonly illustrations1:Illustrations1Controller = new Illustrations1Controller();
    public readonly illustrations2:Illustrations2Controller = new Illustrations2Controller();
    public readonly uploadedImages:UploadedImagesController = new UploadedImagesController();
    public readonly fonts:FontsController = new FontsController();
    public readonly emojis:EmojisController = new EmojisController();
}

export class AnalyticsControllers
{
    public readonly main:AnalyticsController = new AnalyticsController();

    public readonly logRocket:LogRocketController = new LogRocketController();
    public readonly googleAnalytics:GoogleAnalyticsController = new GoogleAnalyticsController();
    public readonly intercom:IntercomController = new IntercomController();
    public readonly cobrowse:CobrowseController = new CobrowseController();
    public readonly hotjar:HotjarController = new HotjarController();
    public readonly upscope:UpscopeController = new UpscopeController();
    public readonly mixpanel:MixpanelController = new MixpanelController();
}

export class CommonControllers
{
    public readonly artifacts:ArtifactsController;
    public readonly designState:DesignStateController = new DesignStateController();
    public readonly surfaceArea:SurfaceAreaController = new SurfaceAreaController();
    public readonly animation:AnimationController = new AnimationController();
    public readonly surfaceDnD:SurfaceDnDController = new SurfaceDnDController();
    public readonly bindings:BindingsController = new BindingsController();
    public readonly spreadsheets:SpreadsheetControllers = new SpreadsheetControllers();
    public readonly buildVersion:BuildVersionController = new BuildVersionController();

    public readonly bases:BasesController = new BasesController();

    public readonly appOAuth2:OAuth2Controller = new OAuth2Controller();

    public readonly flow:FlowController;
    public readonly flowCloud:FlowCloudController = new FlowCloudController();
    public readonly flowSimulation:FlowSimulationController = new FlowSimulationController();
    public readonly flowSimulationStatus:FlowSimulationStatusController = new FlowSimulationStatusController();
    public readonly flowSimulationMessages:FlowSimulationMessagesController = new FlowSimulationMessagesController();

    public readonly assets:AssetsControllers = new AssetsControllers();
    public readonly files:FilesController = new FilesController();

    public readonly cache:CacheController = new CacheController();

    public readonly context:ApplicationContextController;
    public readonly hostContext:HostContextController = new HostContextController();

    public readonly analytics:AnalyticsControllers = new AnalyticsControllers();

    private _initialized:boolean = false;

    public initialize(controllersOverrides:any = {})
    {
        Assert.no(this._initialized);

        //just reassign everything to support controllers overriding
        _merge(this, controllersOverrides);

        this._initialized = true;
    }
}

export const commonControllers:CommonControllers = new CommonControllers();
